import UpdateShopArticleTaxHistoryRequestModelBase from '../_generated/modelBases/update-shop-article-tax-history-request-model-base';

export default class UpdateShopArticleTaxHistoryRequestModel extends UpdateShopArticleTaxHistoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
